export const SITE_NAME = 'Site Muita Mídia'
export const COMPANY_NAME = 'Muita Mídia LTDA'
export const CNPJ = '51.781.940/0001-04'
export const LOGO_URL = 'https://static.lumi.new/material/6f/6ffb231c0bf1e8241c2a2b35b57b91af.png'
export const WHATSAPP_LINK = 'https://wa.me/5531983316620?text=Ol%C3%A1,%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es'
export const EMAIL = 'suporte@muitamidia.com'
export const ADDRESS_LINE_1 = 'Avenida Afonso Pena, 3355 — Sala 1101'
export const ADDRESS_LINE_2 = 'Serra — Belo Horizonte, MG'
export const ADDRESS_CEP = '30130-008'
